import type { SimilarAd } from '@gumtree/shared/src/model/similar-ad.model';

export const UPDATE_SIMILAR_ADS = 'UPDATE_SIMILAR_ADS';

export const updateSimilarAds = (payload: SimilarAd[]) => ({
    type: UPDATE_SIMILAR_ADS,
    payload,
});

export default (state = [] as SimilarAd[], action: ReturnType<typeof updateSimilarAds>) =>
    action.type === UPDATE_SIMILAR_ADS ? action.payload : state;
